import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04469822")

_pushScopeId("data-v-04469822")
const _hoisted_1 = { class: "usecase-item" }
const _hoisted_2 = { class: "head-box" }
const _hoisted_3 = { class: "txt usecase-headline" }
const _hoisted_4 = { class: "txt usecase-body" }
const _hoisted_5 = { class: "txt txt-info" }
const _hoisted_6 = { class: "txt txt-subinfo" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.headline), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.body), 1)
    ]),
    _createVNode("p", _hoisted_5, _toDisplayString(_ctx.text), 1),
    _createVNode("p", _hoisted_6, _toDisplayString(_ctx.subText), 1)
  ]))
})